import { Button, Card, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { paths } from '../../../../../routes/paths';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import { SectionPoolStocks } from './SectionPoolStocks';
import { SectionRewards } from '../lucky-wheel/SectionRewards';
import { SECTION_CARD_SX } from '../shared/sectionCardSx';

export default function BlindBoxProbabilityList() {
  const t = useTranslate();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <PermissionGuard resource="bb-probability" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent maxWidth={false}>
        <CustomBreadcrumbs
          heading={t('module.blindBox.blindBoxProbability')}
          links={[
            { name: t('module.blindBox.title'), href: paths.blindBox.overview.root },
            { name: t('module.blindBox.blindBoxProbability') },
          ]}
          action={
            <Button size="small" variant="outlined" onClick={() => setRefreshKey((k) => k + 1)}>
              {t('module.blindBox.refreshAll')}
            </Button>
          }
        />
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Card variant="outlined" sx={SECTION_CARD_SX}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {t('module.blindBox.blindBoxProbabilityHint')}
            </Typography>
            <SectionRewards refreshKey={refreshKey} modules={['BOX']} />
          </Card>
          <Card variant="outlined" sx={SECTION_CARD_SX}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              {t('module.blindBox.navPool')}
            </Typography>
            <SectionPoolStocks refreshKey={refreshKey} sourceModule="BOX" />
          </Card>
        </Stack>
      </DashboardContent>
    </PermissionGuard>
  );
}
